<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="月度计划名称">
              <global-select
                @change="(val)=>{queryParams.monthPlanVersion=undefined}"
                :value.sync="queryParams.monthPlanName"
                selectType="selectSearch"
                :dropdown-match-select-width="false"
                requestApi="/scp/sopMonthPlan/monthPlanNamePullDown"
                :selectItem="{ value: 'selectedValue', label: 'label' }"
                searchParam="name"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                ref="monthPlanVersionRef"
                :value.sync="queryParams.monthPlanVersion"
                :setParams="{ monthPlanName: queryParams.monthPlanName }"
                selectType="selectSearch"
                requestApi="/scp/sopMonthPlan/monthPlanVersionPullDown"
                :selectItem="{ value: 'selectedValue', label: 'label' }"
                searchParam="monthPlanVersion"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <global-select
                :value.sync="queryParams.status"
                selectType="selectSearch"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastStatus"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="status"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleAdd" type="primary" v-hasPermi="['scp:sopMonthPlan:add']">新建</a-button>
      <a-button @click="handleCalculation" v-hasPermi="['scp:sopMonthPlan:startCalculate']">启动计算</a-button>
      <a-button @click="handleStopCalculation" v-hasPermi="['scp:sopMonthPlan:stopCalculate']">终止计算</a-button>
      <!-- <a-button @click="handleGocomparison">预测对比</a-button> -->
      <a-button @click="handleGoCapacityLoad">查看产能负荷</a-button>
      <!-- <a-button @click="handleGoDemand">查看生产需求</a-button> -->
      <a-button @click="handleGoSummary">进销存汇总</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1400 }"
          @selectedRowChange="selectedRowChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MONTHLY_PLAN_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="monthPlanName" slot-scope="{ record }">
            <a v-if="record.status==='已完成'||record.status==='已发布' || record.status==='已关闭'" @click="handleGoDetail(record)" class="ml10">{{ record.monthPlanName }}</a>
            <span v-else >{{ record.monthPlanName }}</span>

          </span>
          <span slot="period" slot-scope="{ record }">
            <span >{{ `${record.forecastPeriodFrom} ~ ${record.forecastPeriodTo}` }}</span>

          </span>
          <template slot="netSubInventory" slot-scope="{ record }">
            <a-switch :disabled="false" :checked="record.netSubInventory === 'Y'" @change="statusOnChange(record)" />
          </template>
          <span slot="status" slot-scope="{ record }">
            <a @click="handleGoStatus(record)" class="ml10">{{ record.status }}</a>
          </span>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <template slot="safeStockVersion" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.safeStockVersion }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record.safeStockVersion"
              selectType="selectAssembleSearch"
              :dropdown-match-select-width="false"
              :setParams="{ monthStart: $moment(record.currentPeriod).format('YYYYMM') }"
              requestApi="/scp/sopRatioHead/versionCodePullDown"
              :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne' }"
              searchParam="version"
            />
          </template>

          <template slot="sfcNameVersion" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.sfcNameVersion }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record.sfcNameVersion"
              selectType="selectAssembleSearch"
              :dropdown-match-select-width="false"
              requestApi="/scp/scpSopShipmentForecast/listShipmentForecastVersion"
              :setParams="{ monthStart: record.currentPeriod }"
              :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne' }"
              searchParam="version"
            />

          </template>
          <template slot="vendorCapacityVersion" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.vendorCapacityVersion }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record.vendorCapacityVersion"
              selectType="selectAssembleSearch"
              :dropdown-match-select-width="false"
              :setParams="{ monthStart: $moment(record.currentPeriod).format('YYYYMM') }"
              requestApi="/scp/scpSopBasicData/versionList"
              :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'realValue' }"
            />
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="(!isEdit || currentId !== record.id) && record.status !== '已关闭'" @click="handleEdit(record)" v-hasPermi="['scp:sopMonthPlan:edit']">编辑</a>
            <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDel(record)" v-hasPermi="['scp:sopMonthPlan:remove']">删除</a>
            <a v-if="(!isEdit || currentId !== record.id) && record.status !== '已关闭'" class="ml10" @click="handleSend(record)" v-hasPermi="['scp:sopMonthPlan:publishPlan']">发布</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a-popconfirm
              v-if="(!isEdit || currentId !== record.id) && record.status !== '已关闭'"
              title="确定要关闭吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleConfirmClose(record)"
            >
              <a class="ml10" v-hasPermi="['scp:sopMonthPlan:monthPlanClose']">关闭</a>
            </a-popconfirm>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <startCalculation
          ref="startCalculation"
        />
      </div>
    </template>

  </ls-table-layout>
</template>

      <script>
  import { generateLsTableResData } from '@/utils/util.js'
   import startCalculation from './components/startCalculation.vue'
   import { ApiSopMonthPlanList, ApiUpdateSopMonthPlan, ApiSendSopMonthPlan, ApiStartCalculate, ApiStopCalculate, ApiDeleteSopMonthPlan, ApiMonthPlanClose } from '@/api/scp/month-plan/month-plan.js'
   import moment from 'moment';

  export default {
    // eslint-disable-next-line
    name: 'Monthly-plan-workDesk',
    components: {
      startCalculation
    },
    computed: {
    // 其他计算属性
    // ...
    formattedParams () {
      return {
        monthStart: moment(this.currentPeriod).format("YYYYMM")
        // monthEnd: moment(this.baseInfo.forecastPeriodTo).format("YYYYMM")
      };
    }
  },
    data () {
      return {
        moment: moment, // 在 data 中创建 moment 实例
        currentPeriod: '',
        isEdit: false,
        currentId: "",
        lookUpCode: '',
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(ApiSopMonthPlanList, true),
          pageCurrent: true
        },
        // 查询参数
        queryParams: {
            monthPlanName: undefined,
            monthPlanVersion: undefined,
            status: undefined
        },
        baseUomFlagOptions: [
          {
            dictLabel: '是',
            dictValue: 'Y'
          },
          {
            dictLabel: '否',
            dictValue: 'N'
          }
        ],
        // 表格字段
        columns: [
          {
            title: '名称',
            scopedSlots: { customRender: 'monthPlanName' },
            dataIndex: 'monthPlanName',
            align: 'center',
            width: 180,
            ellipsis: true
          },
          {
            title: '期间',
            scopedSlots: { customRender: 'period' },
            dataIndex: 'period',
            align: 'center',
            width: 180,
            ellipsis: true
          },
          {
            title: '版本',
            dataIndex: 'monthPlanVersion',
            ellipsis: true,
            width: 120,
            align: 'center'
          },
          {
            title: '发货预测版本',
            dataIndex: 'sfcNameVersion',
            scopedSlots: { customRender: 'sfcNameVersion' },
            ellipsis: true,
            width: 180,
            align: 'center'
          },
          {
            title: '安全库存版本',
            width: 180,
            dataIndex: 'safeStockVersion',
            scopedSlots: { customRender: 'safeStockVersion' },
            ellipsis: true,
            align: 'center'
          },
          {
            title: '供应商产能版本',
            width: 220,
            dataIndex: 'vendorCapacityVersion',
            scopedSlots: { customRender: 'vendorCapacityVersion' },
            ellipsis: true,
            align: 'center'
          },
          {
            title: '状态',
            width: 120,
            dataIndex: 'status',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '最后更新人',
            width: 120,
            dataIndex: 'updateName',
            align: 'center'
          },
          {
            title: '开始时间',
            width: 180,
            dataIndex: 'createTime',
            align: 'center'
          },
          {
            title: '最后更新日期',
            width: 180,
            dataIndex: 'updateTime',
            scopedSlots: { customRender: 'updateTime' },
            ellipsis: true,
            align: 'center'
          },
          {
            title: '操作',
            width: 180,
            stickyFixed: 'right',
            align: 'center',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' }
          }
        ]
      }
    },
    created () {
     // this.getLastSalesForecast()
   //  this.getLookUpCode('SOP_PROCESS_STATU')
    this.queryParams.monthPlanName = this.$route.query.mpName
    this.queryParams.monthPlanVersion = this.$route.query.mpVersion
    },
    mounted () {
      this.onSearch()
    },
    methods: {
        getLookUpCode (code) {
            const lookupQueryParams = {
                lookupType: code,
                current: 1,
                pageSize: 100
            }
            this.getLookupListData(lookupQueryParams).then().then(response => {
            // this.lookUpCode[code] = response.rows
            this.$set(this.lookUpCode, code, response.rows)
            })
        },
      resetQuery () {
        this.queryParams = {
            monthPlanName: undefined,
            monthPlanVersion: undefined,
            status: undefined
        }
        this.onSearch()
        // 版本
        if(this.$refs?.monthPlanVersionRef) { this.$refs.monthPlanVersionRef.handleSearch(''); }
      },
      handleCalculation () {
        if (this.selectedRowKeys.length > 1) {
          this.$message.error('选项不能超过1项')
          return
        }
        if (this.selectedRowKeys.length === 0) {
          this.$message.error('请选择计算项')
          return
        }
        //  this.$refs.startCalculation.show();
        const id = this.selectedRowKeys[0]
        ApiStartCalculate({ id: id }).then((response) => {
          if (response.code === 200) {
            this.$message.success('启动计算成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      handleStopCalculation () {
        if (this.selectedRowKeys.length > 1) {
          this.$message.error('选项不能超过1项')
          return
        }
        if (this.selectedRowKeys.length === 0) {
          this.$message.error('请选择停止计算项')
          return
        }
        //  this.$refs.startCalculation.show();
        const id = this.selectedRowKeys[0]
        ApiStopCalculate({ id: id }).then((response) => {
          if (response.code === 200) {
            this.$message.success('终止计算成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      handleGoCapacityLoad () {
        /** 检查只能选择一个 */
        if (this.selectedRows.length > 1) {
          this.$message.error('产能负荷的选择项不能大于1')
          return
        }
        if (this.selectedRows.length === 0) {
          this.$message.error('请勾选其中一项')
          return
        }
        this.$router.push({ path: `/monthly-plan/capacityLoadPage/${this.selectedRows[0].monthPlanName}/${this.selectedRows[0].monthPlanVersion}/${this.selectedRows[0].id}` })
      },
      handleGoDemand () {
                /** 检查只能选择一个 */
                if (this.selectedRows.length > 1) {
          this.$message.error('生产需求的选择项不能大于1')
          return
        }
        if (this.selectedRows.length === 0) {
          this.$message.error('请勾选其中一项')
          return
        }
        this.$router.push({ path: `/monthly-plan/productionDemandPage/${this.selectedRows[0].monthPlanName}/${this.selectedRows[0].monthPlanVersion}/${this.selectedRows[0].id}` })
      },
      handleGoSummary () {
                       /** 检查只能选择一个 */
       if (this.selectedRows.length > 1) {
          this.$message.error('生产需求的选择项不能大于1')
          return
        }
        if (this.selectedRows.length === 0) {
          this.$message.error('请勾选其中一项')
          return
        }
        if (this.selectedRows[0].status !== '已完成' && this.selectedRows[0].status !== '已发布') {
          this.$message.error('状态必须为已完成或已发布')
          return
        }
        const monthPlanVersion = this.selectedRows[0].monthPlanVersion
          this.download('scp/sopMonthPlan/invoicingExport', {
            monthPlanVersion: monthPlanVersion
          }, `进销存汇总.xlsx`)
      },
      handleDel (record) {
        const self = this
        this.$confirm({
          title: '提示',
          content: '你确定删除该记录吗？',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            self.deleteShipmentForecast(record)
          },
          onCancel () {
          }
        });
      },
      handleSend (record) {
        if (record.status === '已发布') {
          this.$message.warning('已发布的月度计划，不能再发布')
          return
        }
        if (record.status !== '已完成') {
          this.$message.error('尚未完成计算，请在完成计算后，再发布')
          return
        }
        const self = this
        this.$confirm({
          title: '提示',
          content: '你确定发布该记录吗？',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            self.sendShipmentForecast(record)
          },
          onCancel () {
          }
        });
      },
      handleGoStatus (record) {
        this.$router.push({ path: `/shipmentForecastManagement/runningStatus/${record.id}` })
      },
      deleteShipmentForecast (record) {
        ApiDeleteSopMonthPlan({ id: record.id }).then((response) => {
          if (response.code === 200) {
            this.$message.success('删除成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      sendShipmentForecast (record) {
        ApiSendSopMonthPlan({ id: record.id }).then((response) => {
          if (response.code === 200) {
            this.$message.success('发布成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      handleGoDetail (record) {
        this.$router.push({ path: `/monthly-plan/detail/${record.monthPlanName}/${record.monthPlanVersion}/${record.id}` })
      },
      handleEdit (record) {
        if (this.currentId && record.id !== this.currentId && this.isEdit) {
              this.$message.warning('请保存上次编辑的数据')
              return;
            }
            this.isEdit = true;
            this.currentId = record.id;
      },
      handleAdd () {
        this.$router.push({ path: `/monthly-plan/editPage/` })
      },
      /** 行选中 */
      selectedRowChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      // 表单搜索
      onSearch () {
        this.isEdit = false
        this.$refs.dataTable.searchParams = this.queryParams
        this.$refs.dataTable.getData()
      },
      // 编辑-保存
      handleSave (record) {
        // if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        //   this.$message.warning('折换不能为空且需大于0')
        //   return
        // }
         ApiUpdateSopMonthPlan(record).then(response => {
            if (response.code === 200) {
              this.$message.success('保存成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      statusOnChange (record) {
        record.netSubInventory = record.netSubInventory === 'Y' ? 'N' : 'Y'
      },
      handleConfirmClose (reocrd) {
        ApiMonthPlanClose({ id: reocrd.id }).then(res => {
          if (res.code === 200) {
            this.$message.success(res.msg)
            this.onSearch()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
  </script>

 <style scoped lang="less">
  .ml10 {
    margin-left: 10px;
  }
  /deep/.ant-select{
  width: 100%;
}
  </style>
